export const FUNCTION_TYPES = {
    OP: "OP",
    ROLE: "ROLE" 
}